"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const HubspotGrayscale = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "22", height: "22", viewBox: "0 0 22 22", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.5645 7.68483V5.14334C16.9003 4.98637 17.1847 4.73724 17.3845 4.42494C17.5842 4.11264 17.6912 3.75003 17.6929 3.3793V3.32099C17.6929 2.24008 16.8167 1.36384 15.7358 1.36384H15.6774C14.5965 1.36384 13.7203 2.24008 13.7203 3.32099V3.3793C13.722 3.75003 13.829 4.11264 14.0287 4.42494C14.2285 4.73724 14.5129 4.98637 14.8487 5.14334V7.68483C13.8835 7.83266 12.9744 8.23291 12.2135 8.84507L5.24334 3.416C5.29304 3.23658 5.31897 3.05208 5.3219 2.86689C5.32275 2.43071 5.19422 2.00407 4.95257 1.64095C4.71092 1.27783 4.36701 0.99453 3.96433 0.82689C3.56165 0.65925 3.1183 0.61481 2.69036 0.69917C2.26241 0.78354 1.8691 0.99293 1.56018 1.30085C1.25125 1.60878 1.04059 2.0014 0.954837 2.42907C0.869087 2.85674 0.912097 3.30023 1.07843 3.70345C1.24476 4.10667 1.52694 4.4515 1.88928 4.69433C2.25161 4.93716 2.67783 5.06707 3.11401 5.06763C3.49559 5.06583 3.87002 4.96396 4.19991 4.77219L11.0636 10.1131C9.8017 12.0194 9.8354 14.5038 11.1486 16.3751L9.061 18.4633C8.89218 18.4094 8.71647 18.3807 8.53929 18.3783C7.53952 18.3792 6.7296 19.1899 6.72986 20.1897C6.73012 21.1894 7.54056 21.9997 8.54024 22C9.54 22.0003 10.3508 21.1903 10.3517 20.1906C10.3493 20.0134 10.3206 19.8376 10.2666 19.6689L12.3317 17.603C14.177 19.0235 16.7113 19.1459 18.6849 17.9098C20.6584 16.6736 21.6544 14.3399 21.1815 12.0597C20.7087 9.7795 18.8668 8.03436 16.5645 7.68483ZM15.7085 16.0436C15.3269 16.0539 14.9472 15.9876 14.5917 15.8487C14.2362 15.7098 13.9122 15.501 13.6387 15.2348C13.3652 14.9686 13.1478 14.6503 12.9994 14.2986C12.851 13.947 12.7745 13.5692 12.7745 13.1876C12.7745 12.8059 12.851 12.4281 12.9994 12.0765C13.1478 11.7248 13.3652 11.4065 13.6387 11.1403C13.9122 10.8741 14.2362 10.6653 14.5917 10.5264C14.9472 10.3875 15.3269 10.3212 15.7085 10.3315C17.246 10.3853 18.4648 11.6469 18.4656 13.1855C18.4663 14.7239 17.2488 15.9868 15.7113 16.0421",
        fill: "#8790A6",
        fillOpacity: 0.6
      }
    )
  );
};
export default HubspotGrayscale;
